import { AuthenticationService } from '@knockrentals/knock-react';
import { BASE_ANALYTICS_URI } from '../config';
import {
  ACCESS_TOKEN_LOGIN_TYPE,
  ACCESS_TOKEN_LOGIN_TYPES,
  QUERY_STRING_PARAMS,
} from '../constants';

export const ANALYTICS_BASE_LOGIN_URL = `${BASE_ANALYTICS_URI}/login`;

export const isMasterRole = () => {
  const role = AuthenticationService.getRole() || '';
  return role.toUpperCase() === 'MASTER';
};

export const getUnifiedLoginTypeQueryParam = (isUseCookieForTokenEnabled) => {
  const loginType = localStorage.getItem(ACCESS_TOKEN_LOGIN_TYPE);
  const querySymbol = isUseCookieForTokenEnabled ? '?' : '&';

  return loginType === ACCESS_TOKEN_LOGIN_TYPES.UNIFIED
    ? `${querySymbol}${QUERY_STRING_PARAMS.LOGIN_TYPE}=${ACCESS_TOKEN_LOGIN_TYPES.UNIFIED}`
    : '';
};

export const getAnalyticsLoginUrl = (
  tokenValue,
  isUseCookieForTokenEnabled
) => {
  const unifiedLoginTypeQueryParam = getUnifiedLoginTypeQueryParam(
    isUseCookieForTokenEnabled
  );

  const queryParams = isUseCookieForTokenEnabled
    ? unifiedLoginTypeQueryParam
    : `?accessToken=${tokenValue}${unifiedLoginTypeQueryParam}`;

  return `${ANALYTICS_BASE_LOGIN_URL}${queryParams}`;
};
